// Chip — filtro click. Activo: bg-ink. Inactivo: bg-bg2.

export default function Chip({ children, active = false, onClick, count, className = '' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-2 h-7 px-3 rounded-pill text-[12px] border transition-colors ${
        active
          ? 'bg-[var(--ink)] text-[var(--bg)] border-[var(--ink)]'
          : 'bg-[var(--bg-2)] text-[var(--ink-2)] border-[var(--line)] hover:bg-[var(--bg-3)]'
      } ${className}`}
    >
      <span>{children}</span>
      {count != null && (
        <span className={`tnum text-[10.5px] ${active ? 'opacity-70' : 'text-[var(--ink-3)]'}`}>{count}</span>
      )}
    </button>
  )
}
